import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { History, Filter } from "lucide-react";

const EVENT_TONE = {
  shop_suspended: "bg-red-500/15 text-red-300 border-red-500/30",
  shop_activated: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  shop_updated: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  shop_password_reset: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  admin_impersonation_started: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  distributor_activated: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  distributor_suspended: "bg-red-500/15 text-red-300 border-red-500/30",
  distributor_rejected: "bg-slate-700 text-slate-300 border-slate-600",
  plan_created: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  plan_updated: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  plan_deleted: "bg-red-500/15 text-red-300 border-red-500/30",
  hard_delete_customer: "bg-red-600/20 text-red-300 border-red-500/40",
  hard_delete_loan: "bg-red-600/20 text-red-300 border-red-500/40",
  hard_delete_payment: "bg-red-600/20 text-red-300 border-red-500/40",
  hard_delete_shop: "bg-rose-600/20 text-rose-300 border-rose-500/40",
  hard_delete_referral_partner: "bg-rose-600/20 text-rose-300 border-rose-500/40",
  hard_delete_password_failed: "bg-amber-500/15 text-amber-300 border-amber-500/30",
};

export default function AdminActivity() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = (event) => {
    let qs = "";
    if (event === "hard_delete_all") {
      qs = "?event_prefix=hard_delete_";
    } else if (event && event !== "all") {
      qs = `?event=${event}`;
    }
    api.get(`/admin/activity${qs}`).then((r) => setRows(r.data));
  };
  useEffect(() => { load(filter); }, [filter]);

  const events = ["all", "hard_delete_all", "shop_suspended", "shop_activated", "shop_updated", "shop_password_reset",
    "admin_impersonation_started", "distributor_activated", "distributor_suspended",
    "distributor_rejected", "plan_created", "plan_updated", "plan_deleted"];

  return (
    <div className="space-y-6" data-testid="admin-activity-page">
      <div>
        <h1 className="font-display text-3xl font-bold text-white">Activity Logs</h1>
        <p className="text-slate-400 mt-1">Critical events: suspend / activate / plan changes / impersonation.</p>
      </div>

      <div className="bg-[#151A23] border border-slate-800 rounded-md">
        <div className="p-4 border-b border-slate-800 flex flex-wrap items-center gap-2">
          <Filter className="w-4 h-4 text-slate-400" />
          {events.map((e) => (
            <button key={e} onClick={() => setFilter(e)} data-testid={`activity-filter-${e}`}
              className={`px-2.5 py-1 rounded-md text-xs font-semibold border ${filter === e ? "bg-amber-500 border-amber-500 text-slate-900" : "border-slate-700 text-slate-300 hover:bg-slate-800"}`}>
              {e === "hard_delete_all" ? "All hard deletes" : e.replace(/_/g, " ")}
            </button>
          ))}
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-900 text-slate-400">
              <tr>
                <th className="text-left px-4 py-3 font-semibold">When</th>
                <th className="text-left px-4 py-3 font-semibold">Event</th>
                <th className="text-left px-4 py-3 font-semibold">Target</th>
                <th className="text-left px-4 py-3 font-semibold">Actor</th>
                <th className="text-left px-4 py-3 font-semibold">Meta</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-slate-500">No activity yet.</td></tr>}
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-slate-800" data-testid={`activity-row-${r.id}`}>
                  <td className="px-4 py-3 text-xs tabular text-slate-400">
                    {(r.created_at || "").slice(0, 19).replace("T", " ")}
                  </td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold border ${EVENT_TONE[r.event] || "border-slate-700 text-slate-300"}`}>
                      <History className="w-3 h-3" />{r.event.replace(/_/g, " ")}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-white">{r.target_label || r.target_id?.slice(0, 8)}</td>
                  <td className="px-4 py-3 text-slate-400 text-xs tabular">{r.actor_email}</td>
                  <td className="px-4 py-3 text-slate-500 text-xs">
                    {r.meta && Object.keys(r.meta).length > 0 ? JSON.stringify(r.meta) : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
